import { Toast } from '@core/models/toast/toast';
import { ToastType } from '@core/models/toast/toast-type';
import { NoAction } from '@core/state/shared/actions/no-action';
import { SetToastAction } from '@core/state/toast/toast.actions';
import { $log } from '@core/utils/logger';
import { Action } from '@ngrx/store';
import { OperatorFunction } from 'rxjs';
import { catchError } from 'rxjs/operators';

/**
 * resultActions returns the error toast
 *
 * @param {*} fn
 * @returns
 */
export const ossCatchError = (fn: any): OperatorFunction<Action, any> => {
    return catchError(errorResponse => {
        $log.error('Error logged in ossCatchError \n', errorResponse || JSON.stringify(errorResponse));

        let errorText: string = 'Errors.Unknown';

        // if error is thrown from backend, the api response would contain error info structured
        // in this format
        if (errorResponse && errorResponse.error && errorResponse.error.error) {
            errorText = errorResponse.error.error;
        }

        const toastAction: Action = new SetToastAction(new Toast(ToastType.ERROR, errorText, errorResponse && errorResponse.error));

        let resultActions: any[] = [toastAction];

        return fn([resultActions, errorResponse]);
    });
};